<app-common-loader *ngIf="carregandoTarefas"></app-common-loader>

<div class="tarefas-container">
  <app-page-hero
    icone="task_alt"
    titulo="Tarefas por Obras"
    [badge]="totalObras || null"
    subtitulo="Acompanhe e gerencie suas tarefas relacionadas a obras."
  >
    <button
      class="btn-hero btn-hero-excluir"
      type="button"
      *ngIf="!carregandoTarefas && tarefas?.length > 0 && isAllSelected()"
      (click)="abrirModalExcluir()"
    >
      <mat-icon>delete_outline</mat-icon>
      Excluir selecionados
    </button>
    <button class="btn-hero" type="button" (click)="abrirModal()">
      <mat-icon>add</mat-icon>
      Criar tarefa
    </button>
  </app-page-hero>

  <nav class="abas">
    <button
      *ngFor="let status of statusTabs"
      type="button"
      class="aba"
      [class.ativa]="statusSelecionado === status.key"
      (click)="mudarAba(status.key)"
    >
      {{ status.label }}
    </button>
  </nav>

  <div class="filtros">
    <app-filtro-select-busca
      [value]="filtroResponsavel"
      [options]="opcoesResponsaveis"
      placeholder="Todos os responsáveis"
      placeholderBusca="Buscar responsável"
      (valueChange)="onResponsavelSelecionado($event)"
    ></app-filtro-select-busca>

    <div class="filtro-periodo-wrapper input-filtro-selecionado">
      <input
        type="text"
        bsDaterangepicker
        [(ngModel)]="intervaloSelecionado"
        [bsConfig]="config"
        (ngModelChange)="onPeriodoChange()"
        class="input-periodo"
        placeholder="Todos os períodos"
        readonly
      />
      <button
        *ngIf="intervaloSelecionado?.length"
        type="button"
        class="btn-clear"
        (click)="limparPeriodo()"
      >
        ×
      </button>
    </div>

    <div class="custom-dropdown">
      <div class="input-filtro-selecionado">
        <button
          type="button"
          class="dropdown-toggle"
          (click)="toggleTipoObra()"
        >
          <img
            src="{{
              BASE_IMG_URL
            }}assets/agenda-tarefas/filter.svg"
            width="20"
            height="20"
          />
          {{
            filtroTipoObraSelecionados.length === 0
              ? "Todos os tipos de obra"
              : filtroTipoObraSelecionados.length + " tipo(s) selecionado(s)"
          }}
        </button>
        <button
          *ngIf="filtroTipoObraSelecionados?.length"
          type="button"
          class="btn-clear"
          (click)="limparTiposObra()"
        >
          ×
        </button>
      </div>
      <div *ngIf="mostrarTipoObra" class="dropdown-list">
        <label *ngFor="let tipo of tiposObra">
          <input
            type="checkbox"
            class="checkbox"
            [checked]="filtrosAtivos.tiposObra.includes(tipo.moduleID)"
            (change)="
              onTipoObraToggle(tipo.moduleID, $event); onTipoObraChange()
            "
          />
          {{ tipo.module }}
        </label>
      </div>
    </div>

    <app-filtro-select-busca
      [value]="filtroTipoTarefa"
      [options]="opcoesTipoTarefa"
      placeholder="Todos os tipos de tarefa"
      placeholderBusca="Buscar tipo de tarefa"
      (valueChange)="onTipoTarefaSelecionado($event)"
    ></app-filtro-select-busca>

    <app-filtro-busca-texto
      [value]="termoBusca"
      placeholder="Buscar por obra"
      (valueChange)="onBuscaChange($event)"
    ></app-filtro-busca-texto>
  </div>

  <app-filtros-aplicados
    [tags]="tagsFiltros"
    (remover)="removerFiltro($event.key, $event.valor)"
    (limpar)="limparTodosFiltros()"
  ></app-filtros-aplicados>

  <div
    *ngIf="tarefas && tarefas.length === 0 && !carregandoTarefas"
    class="no-results-container"
  >
    <div class="no-results">
      <p>Nenhuma tarefa encontrada!</p>
      <button class="btn btn-primary" type="button" (click)="abrirModal()">
        Criar nova tarefa
      </button>
    </div>
  </div>

  <div class="card-listagem" *ngIf="tarefas && tarefas.length > 0">
  <div class="tabela-wrapper">
  <table class="tabela-tarefas">
    <colgroup>
      <col class="col-check" />
      <col class="col-data" />
      <col class="col-empresa" />
      <col class="col-obra" />
      <col class="col-tipo" />
      <col class="col-acao" />
      <col class="col-responsavel" />
      <col class="col-contato" />
      <col class="col-status" />
      <col class="col-anotacao" />
      <col class="col-acoes" />
    </colgroup>
    <thead>
      <tr>
        <th>
          <input
            type="checkbox"
            class="checkbox"
            (change)="selecionarTodosTarefas($event)"
            [checked]="isAllSelected()"
          />
        </th>
        <th appThOrdenavel="followUpDate" [ordenacao]="ordenacao" (ordenar)="ordenarPorCampo($event)">
          Data
        </th>
        <th appThOrdenavel="companyName" [ordenacao]="ordenacao" (ordenar)="ordenarPorCampo($event)">
          Empresa
        </th>
        <th appThOrdenavel="workName" [ordenacao]="ordenacao" (ordenar)="ordenarPorCampo($event)">
          Obra
        </th>
        <th appThOrdenavel="workType" [ordenacao]="ordenacao" (ordenar)="ordenarPorCampo($event)">
          Tipo de obra
        </th>
        <th appThOrdenavel="actionDescription" [ordenacao]="ordenacao" (ordenar)="ordenarPorCampo($event)">
          Ação
        </th>
        <th appThOrdenavel="responsibleName" [ordenacao]="ordenacao" (ordenar)="ordenarPorCampo($event)">
          Responsável
        </th>
        <th>Contato</th>
        <th appThOrdenavel="statusDescription" [ordenacao]="ordenacao" (ordenar)="ordenarPorCampo($event)">
          Status
        </th>
        <th>Anotação</th>
        <th>Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let t of tarefas; trackBy: trackByTaskId">
        <td>
          <input
            type="checkbox"
            [(ngModel)]="t.selecionada"
            (change)="onTarefaSelecionada(t)"
            class="checkbox"
          />
        </td>
        <td>{{ t.followUpDate | date : "dd/MM/yyyy HH:mm" }}</td>

        <td class="celula-destaque" [title]="t.companyName">
          <a href="#" (click)="$event.preventDefault(); onEmpresaClick(t)">
            {{ t.companyName }}
          </a>
        </td>

        <td class="celula-destaque" [title]="t.workName">
          <a (click)="abrirObra(t)">{{ t.workName }}</a>
        </td>

        <td>
          <span
            class="tag"
            [ngClass]="getTagClass(t.workType)"
            [style.background]="getTipoObraColor(t.workType)"
            [title]="t?.workType"
            >{{ t?.workType }}</span
          >
        </td>
        <td [title]="t?.actionDescription">{{ t?.actionDescription }}</td>
        <td [title]="t.responsibleName">{{ t.responsibleName }}</td>
        <td>
          <div class="celula-contato">
            <strong class="contact-name" [title]="t.contactName">{{ t.contactName }}</strong>
            <small [title]="t?.contactRole">{{ t?.contactRole }}</small>
            <a
              class="contato-email"
              *ngIf="t.contactEmail"
              [href]="'mailto:' + t.contactEmail"
              [title]="t.contactEmail"
              >{{ t.contactEmail }}</a
            >
            <span class="contato-telefone">{{ t?.contactPhone }}</span>
          </div>
        </td>
        <td>
          <span class="status" [ngClass]="getStatusClass(t.statusDescription)">{{
            t?.statusDescription
          }}</span>
        </td>

        <td [title]="t.description || 'Sem anotação'">
          {{ t.description || "Sem anotação" }}
        </td>
        <td>
          <div class="btn-acoes-lista">
            <button
              type="button"
              class="btn-excluir-tarefa"
              title="Excluir tarefa"
              (click)="abrirModalExcluir(t.taskID)"
            >
              <mat-icon>delete_outline</mat-icon>
            </button>

            <button
              type="button"
              class="btn-concluir-tarefa"
              title="Concluir tarefa"
              (click)="abrirModalConcluirTarefa(t)"
            >
              <mat-icon>check</mat-icon>
            </button>
            <button
              type="button"
              class="btn-editar-tarefa"
              title="Editar tarefa"
              (click)="abrirModalEditarTarefa(t)"
            >
              <mat-icon>edit_note</mat-icon>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  </div>
  </div>

  <small class="exibe-pag" *ngIf="tarefas?.length > 0">
    Exibindo {{ tarefas?.length }} de {{ totalObras }} tarefas
  </small>

  @if (this.tarefasFiltradas.length >= 25 || this.totalObras >= 25) {
  <div class="d-flex justify-content-center align-items-center mt-3">
    <app-paginacao-tarefas
      [paginacao]="{
        page: currentPage,
        pageFirst: 1,
        pageLast: totalPages,
        pageNext: currentPage < totalPages ? currentPage + 1 : null,
        pagePrev: currentPage > 1 ? currentPage - 1 : null,
        recordsCount: tarefasFiltradas.length,
        pageActive: true,
        pageSize: 10,
        shortcuts: 0,
        hasValue: tarefasFiltradas.length > 0,
        shortcutPages: [],
        records: tarefasFiltradas
      }"
      (paginaMudada)="mudarPagina($event)"
    ></app-paginacao-tarefas>
  </div>
  }

  <app-concluir-tarefa
    *ngIf="mostrarModalConcluir"
    [taskID]="taskID"
    (tarefaConcluida)="onTarefaConcluida()"
    (fecharDialogo)="fecharModalConcluirTarefa($event)"
  >
  </app-concluir-tarefa>

  <app-excluir-tarefas
    [taskID]="taskID"
    [selectedTaskIds]="selectedTaskIds"
    *ngIf="mostrarModalExcluir"
    (fecharDialogo)="fecharModalExcluir($event)"
    (loading)="carregandoTarefas = $event"
  ></app-excluir-tarefas>
  <app-editar-tarefa-criada
    *ngIf="mostrarModalEditar"
    [tarefaSelecionada]="tarefaSelecionada"
    (fecharDialogo)="fecharModalEditarTarefa()"
    (tarefaEditada)="carregarTarefas()"
  ></app-editar-tarefa-criada>
</div>
